import {observer} from "mobx-react"
import React, {Component} from "react"
import CSV from "components/CSV/CSV"
import _ from "lodash"
import LineItem from "sdk/LineItem"
import {Button, Form, Icon, Modal, Table} from "semantic-ui-react"
import shop from "shop/shop"
import exportStore from "stores/exportStore"
import QuickorderLineItem from "components/Quickorder/QuickorderLineItem"


function uuid() {
	let firstPart = (Math.random() * 46656) | 0;
	let secondPart = (Math.random() * 46656) | 0;
	firstPart = ("000" + firstPart.toString( 36 )).slice( -3 );
	secondPart = ("000" + secondPart.toString( 36 )).slice( -3 );
	return firstPart + secondPart;
}


@observer
export default class ProductImporter extends Component {

	state = {
		open          : false,
		productsLoaded: false,
		name          : ""
	}


	componentDidMount() {
		this.props.defaultName && this.setState( {name: this.props.defaultName} )
	}

	handleImport = () => {
		const {positions} = exportStore

		if ( this.props.onSuccess ) {
			let ok = this.props.onSuccess( positions.map( entry => entry.product ), {name: this.state.name || uuid()} )
			if ( ok ) return this.setState( {open: false} )
			return
		}

		positions.map( lineItem => {
			shop.cart.add( lineItem.product )
		} )

		this.setState( {open: false} )
	}

	render() {
		const {open, productsLoaded} = this.state
		const {positions} = exportStore

		return (
			<React.Fragment>
				<Button basic onClick={() => this.setState( {open: true} )}><Icon name="upload" /> {translate( "import" )}</Button>
				<Modal
					closeIcon={<Icon name="close" />}
					open={open}
					onClose={() => {
						if ( this.state.productsLoaded ) {
							this.setState( {productsLoaded: false} )
							return
						}
						this.setState( {open: false} )
					}}
					size={productsLoaded ? "large" : "tiny"}
				>
					<Modal.Header>{translate( "import products" )}</Modal.Header>
					<Modal.Content>

						{productsLoaded && <div>

							<label htmlFor="">{translate( "Name" )}</label>
							<Form.Input value={this.state.name} onChange={( e ) => {
								this.setState( {name: e.currentTarget.value} )
							}} />
							<Table celled compact>
								<Table.Header>
									<Table.Row>
										<Table.HeaderCell width={1}> </Table.HeaderCell>
										<Table.HeaderCell width={1}>{translate( "Nr." )}</Table.HeaderCell>
										<Table.HeaderCell width={3}>{translate( "Artikel-Nr." )}</Table.HeaderCell>
										<Table.HeaderCell width={5}>{translate( "Produkt" )}</Table.HeaderCell>
										<Table.HeaderCell width={1}>
											<div className="black-70 tc"><Icon name="truck" /></div>
										</Table.HeaderCell>
										<Table.HeaderCell width={4}>Anzahl</Table.HeaderCell>
										<Table.HeaderCell width={1} textAlign={"right"}>&nbsp;</Table.HeaderCell>
									</Table.Row>

									{positions.map( ( lineItem, index ) => {
										return <QuickorderLineItem key={lineItem.key} index={index} lineItem={lineItem} />
									} )
									}

								</Table.Header>
							</Table>
						</div>

						}


						{!productsLoaded && <React.Fragment>
							<CSV skipFirstLine onText={( {positions} ) => {
								exportStore.positions = []
								exportStore.positionById = new Map()

								console.log( "RESULT", {positions} )
								_.each( positions, (product => {
										exportStore.positions.push( new LineItem( product.id, Number( product.count ) ) )
									})
								)
								shop.toast( translate( "products successfully imported" ), "success", false, "bottom" )
								this.setState( {productsLoaded: true} )
							}


							} />
							<div className="bg-silver pa4">
								<p>{translate( "UPLOAD_NOTIFICATION" )}<a
									download={`Bestellvorlage.csv`}
									href="/Bestellvorlage.csv">{`Bestellvorlage.csv`}</a>.</p>
							</div>
						</React.Fragment>
						}
					</Modal.Content>

					<Modal.Actions>
						{(positions.length > 0 && !productsLoaded) && <div>
							<Button onClick={() => {
								this.setState( {productsLoaded: true} )
							}} basic><Icon name={"clock"} /> {translate( "Letzten Datensatz anzeigen" )}</Button>
						</div>}
					</Modal.Actions>

					{productsLoaded && <Modal.Actions>
						<Button
							onClick={this.handleImport}
							loading={exportStore.loading} positive icon="checkmark" labelPosition="right" content={translate( "Importieren" )} />
					</Modal.Actions>
					}

				</Modal>
			</React.Fragment>

		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Product/ProductImporter.js